/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum PoliJobsReportSortFieldEnum {
	CvSharesCount = "CvSharesCount",
	CvDownloadsCount = "CvDownloadsCount",
}

export function PoliJobsReportSortFieldEnumFromJSON(
	json: any
): PoliJobsReportSortFieldEnum {
	return PoliJobsReportSortFieldEnumFromJSONTyped(json, false);
}

export function PoliJobsReportSortFieldEnumFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PoliJobsReportSortFieldEnum {
	return json as PoliJobsReportSortFieldEnum;
}

export function PoliJobsReportSortFieldEnumToJSON(
	value?: PoliJobsReportSortFieldEnum | null
): any {
	return value as any;
}
